const baseURL = 'https://www.reddit.com/api/v1/';
const redirectURL = 'https://beta.satelite.app/auth/';
const clientID = 'd8BQpWDji32NvQ';
const state = 'newsateliterequest';

export { baseURL, redirectURL, clientID, state };
